/**
 * Created by JackCui on 2021/12/2
 */

import Store from 'fe-coms-share/utils/catch-state/store'

export default Store
